import find from 'lodash/find';
import get from 'lodash/get';
import sortBy from 'lodash/sortBy';
import { useMemo } from 'react';

import agentsResource from 'src/actions/agent/agentsResource';
import chatCampaignsResource from 'src/actions/chatCampaigns/chatCampaignsResource';
import { toDateTimeString } from 'src/presentation/components/pages/shared/utils/TimeUtils';
import useResource, { STATUS_SUCCEEDED, STATUS_LOADING } from 'src/presentation/hooks/useResource';

const useChatCampaignsWithAgents = () => {
  const { errors, loadingState, values: campaigns } = useResource(chatCampaignsResource);
  const { values: agents, loadingState: agentsLoadingState } = useResource(agentsResource);

  const chatCampaigns = useMemo(
    () =>
      sortBy(
        campaigns.map(campaign => {
          const updatedAtString = toDateTimeString(campaign.updatedAt);
          const updatedById = get(campaign, 'updatedBy.id');
          const updatedByAgent = find(agents, agent => agent.id === updatedById);
          const agentName = get(updatedByAgent, 'name');
          return { ...campaign, updatedAtString, updatedByString: agentName };
        }),
        item => item.priority
      ),
    [campaigns, agents]
  );

  const state =
    loadingState === STATUS_SUCCEEDED && agentsLoadingState === STATUS_SUCCEEDED ? STATUS_SUCCEEDED : STATUS_LOADING;

  return { errors, loadingState: state, chatCampaigns };
};

export default useChatCampaignsWithAgents;
